export const URL_PATTERN = /(https?:\/\/[^\s)]+|www\.[^\s)]+)/gi;

export function toSafeHttpHref(rawUrl) {
  if (!rawUrl || typeof rawUrl !== 'string') return null;
  const href = rawUrl.startsWith('http') ? rawUrl : `https://${rawUrl}`;
  try {
    const parsed = new URL(href);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }
    return parsed.href;
  } catch (_) {
    return null;
  }
}

export function extractUrlFromText(text) {
  const match = String(text || '').match(URL_PATTERN);
  return match ? match[0] : '';
}

export function linkLabelFromUrl(url) {
  const safeHref = toSafeHttpHref(url);
  if (!safeHref) return 'Hap faqen zyrtare';
  try {
    const parsed = new URL(safeHref);
    if (!/dpshtrr\.al/i.test(parsed.hostname)) return 'Hap faqen zyrtare';
    const slug = parsed.pathname.split('/').filter(Boolean).pop() || 'dpshtrr';
    return slug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  } catch (_) {
    return 'Hap faqen zyrtare';
  }
}
